// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import NProgress from "nprogress";
import { __TOKEN_KEY__ } from "./api/common";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN";
import DlgDraggable from "vue-element-dialog-draggable";

Vue.use(DlgDraggable, { containment: true });
Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.use(DlgDraggable, { containment: true });

const whiteList = ['/login', '/pdf_report']; // 白名单路径

// 登录验证
router.beforeEach((to, from, next) => {
  NProgress.start();
  // 调用next方法之前，可以进行授权拦截
  if (to.meta.requireAuth) {
    let token = window.sessionStorage.getItem("__TOKEN_KEY__");
    if (token && token !== "") {
      next();
    } else {
      if (whiteList.includes(to.path)) {
        next();
      } else {
        next({
          path: "/login",
          query: {
            redirect: to.fullPath
          }
        });
      }
    }
  } else {
    next();
  }
});
router.afterEach(() => {
  NProgress.done();
});

// tslint:disable-next-line:no-unused-expression
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  }
});
